export default "__VITE_ASSET__B9AToWwe__"